/**
 * This utility is intended to be used to parse or format numbers only.
 * It should not be used to format currency as it does not have logic to handle rounding up/down,
 * therefore making the output inaccurate.
 */

function countDecimals(value: number | string): number {
    if (Math.floor(Number(value)) === value) {
        return 0;
    }

    const decimals = value.toString().split(".");

    return decimals[1] ? decimals[1].length : 0;
}

export function convertStringToNumber(numberInString: string): null | string {
    const number = parseFloat(numberInString);

    if (isNaN(number)) {
        return null;
    }

    const decimalPoints = numberInString.split(".")[1] ? numberInString.split(".")[1].length : 0;

    return parseFloat(numberInString).toFixed(decimalPoints);
}

export function zeroPad(number: number | string): string {
    const isNumber = typeof number === "number";
    const isString = typeof number === "string";

    if (!isNumber && !isString) {
        return "";
    }

    const numberToPad = isString ? convertStringToNumber(number as string) : number;

    if (!numberToPad) {
        return "";
    }

    const decimalPoints = countDecimals(numberToPad);
    const sign = numberToPad < 0 ? "-" : "";
    const absoluteValue = Math.abs(Number(numberToPad)).toFixed(decimalPoints);

    return `${ sign }0${ absoluteValue }`;
}

export function to2DecimalPriceString(value?: number): undefined | string {
    if (typeof value !== "number") {
        return undefined;
    }

    if (value === 0) {
        return "$0";
    }

    if (countDecimals(value) === 0) {
        return `$${ Math.floor(value) }`;
    }

    return `$${ value.toFixed(2) }`;
}

export function formatWithCommasAndDecimals(number?: number, dp = 2): string {
    if (typeof number !== "number") {
        return "";
    }

    const numberWithDecimals = number.toFixed(dp);

    return commafy(numberWithDecimals);
}

function commafy(numberString: string): string {
    if (typeof numberString !== "string") {
        return numberString;
    }

    if (numberString.indexOf(".") > 0) {
        return numberString.replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }

    return numberString.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
